import React from 'react';
import AddCityForm from '../components/AddCityForm';
import WeatherList from '../components/WeatherList';

const HomePage: React.FC = () => (
  <div style={{ maxWidth: 900, margin: '0 auto', padding: 16 }}>
    <h1>Weather in cities</h1>
    <AddCityForm />
    <WeatherList />
  </div>
);

export default HomePage; 